module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-about-office"
  }, [_c('div', {
    staticClass: "tabs-about-office__bg"
  }, [_c('div', {
    staticClass: "tabs-about-office__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "tabs-about-office__title",
    class: {
      "tabs-about-office__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  })]), _c('div', {
    staticClass: "tabs-about-office__gallery-container"
  }, _vm._l((_vm.props.gallery), function(image, i) {
    return _c('div', {
      key: i,
      staticClass: "tabs-about-office__image",
      style: ("background-image: url(" + image.url + ");"),
      on: {
        "click": function($event) {
          _vm.displayOfficeTourModal(i)
        }
      }
    })
  })), _vm._m(0)]), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [(_vm.showModal) ? _c('OfficeTourModal', {
    attrs: {
      "props": _vm.props,
      "index": _vm.imageIndex
    },
    on: {
      "closeOfficeTourModal": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-about-office__link"
  }, [_c('a', {
    staticClass: "tabs-about-office__link1",
    attrs: {
      "href": "/",
      "target": "_blank"
    }
  }, [_vm._v("START YOUR SMILE JOURNEY HERE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92e59336","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tabs/tabs-about-office/tabs-about-office.pug
// module id = 592
// module chunks = 1